import React from 'react';

import * as Styled from './placeholder.style';
import { TimelineDropAnchors } from './types';

export type PlaceholderProps = {
  dayWidth: number;
  dayIndex: number;
  durationDays: number;
  anchor?: TimelineDropAnchors;
};

export const Placeholder: React.FC<PlaceholderProps> = ({
  dayWidth,
  dayIndex,
  durationDays,
  anchor = TimelineDropAnchors.Centered,
}) => {
  const width = durationDays * dayWidth;
  const snappedX = dayIndex * dayWidth;
  const left =
    anchor === TimelineDropAnchors.StartAtCursor
      ? snappedX
      : snappedX - width / 2;

  return (
    <Styled.Container
      $width={durationDays * dayWidth}
      style={{ left: `${left}px` }}
    />
  );
};
